import { Component, Renderer2 } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'my-app',
  templateUrl: './dining-guide.component.html',
  styleUrls: ['./dining-guide.component.css']
})
export class DiningGuideComponent {

  regionsLevel1: any = null;
  regionsLevel2: any = null;

  selectedRegionIdLevel1: number = 0;
  selectedRegionNameLevel1: string;
  selectedRegionFriendlyUrlLevel1: string;

  selectedRegionIdLevel2: number = 0;
  selectedRegionNameLevel2: string;
  selectedRegionFriendlyUrlLevel2: string;

  selectedRegionIdLevel3: number = 0;

  childrenRegions: any = null;
  childrenRegionsChildren: any = null;
  //winWidth: number = 0;

  constructor(private _http: Http, private renderer: Renderer2) {

  }

  ngOnInit() {
    this.getLevel1Regions();
    //this.winWidth = window.innerWidth;
    //console.log("DG-v2 works!");
  }

  getLevel1Regions() {
    this.regionsLevel1 = null;
    var enabledOnly = true;
    this._http.get(`region/getalllevel1/${enabledOnly}/false`).toPromise().then((data) => {
      this.regionsLevel1 = data.json();
      //console.log("getLevel1Regions called; this.regionsLevel1", this.regionsLevel1);
      if (this.selectedRegionIdLevel1 === 0) {
        this.selectedRegionIdLevel1 = this.regionsLevel1.filter(function (o) { return o.name == "Europe" })[0].id;
        this.selectedRegionNameLevel1 = this.regionsLevel1.filter((o) => { return o.id == this.selectedRegionIdLevel1 })[0].name;
        this.selectedRegionFriendlyUrlLevel1 = this.regionsLevel1.filter((o) => { return o.id == this.selectedRegionIdLevel1 })[0].friendlyUrl;
        //console.log("R-lev1-Furl=", this.selectedRegionFriendlyUrlLevel1);
      }
      this.getRegionsChildren(this.selectedRegionIdLevel1);
    }).catch();
  }

  getRegionsChildren(id) {
    this.childrenRegions = null;
    this.selectedRegionIdLevel1 = id;
    this.selectedRegionNameLevel1 = this.regionsLevel1.filter((o) => { return o.id == this.selectedRegionIdLevel1 })[0].name;
    this._http.get("region/getsubregionsbyparentid/" + this.selectedRegionIdLevel1).toPromise().then((data) => {
      this.childrenRegions = data.json();
      //console.log("getRegionsChildren called; id//this.childrenRegions", id, this.childrenRegions);
    }).catch();
  }

  clickGetRegionsChildren(id) {
    this.childrenRegions = null;
    this.selectedRegionIdLevel1 = id;
    this.selectedRegionNameLevel1 = this.regionsLevel1.filter((o) => { return o.id == this.selectedRegionIdLevel1 })[0].name;
    this.selectedRegionFriendlyUrlLevel1 = this.regionsLevel1.filter((o) => { return o.id == this.selectedRegionIdLevel1 })[0].friendlyUrl;
    this._http.get("region/getsubregionsbyparentid/" + this.selectedRegionIdLevel1).toPromise().then((data) => {
      this.childrenRegions = data.json();
      //console.log("clickGetRegionsChildren called; id//this.childrenRegions", id, this.childrenRegions);
      if (innerWidth < 767 && this.childrenRegions !== null && this.childrenRegions.length > 0) {
        this.renderer.addClass(document.body, 'fixed-countries');
      }
    }).catch();
  }

  /*clickGetRegionsChildrenChildren(id) {
    this.childrenRegionsChildren = null;
    this.selectedRegionIdLevel2 = id;
    this.selectedRegionNameLevel2 = this.regionsLevel2.filter((o) => { return o.id == this.selectedRegionIdLevel2 })[0].name;
    this._http.get("region/getallbyparentid/" + this.selectedRegionIdLevel2).toPromise().then((data) => {
      this.childrenRegionsChildren = data.json();
      //console.log("clickGetRegionsChildrenChildren called; id//this.childrenRegionsChildren", id, this.childrenRegionsChildren);
      if (innerWidth < 767 && this.childrenRegionsChildren !== null && this.childrenRegionsChildren.length > 0) {
        this.renderer.addClass(document.body, 'fixed-countries');
      }
    }).catch();
  }*/

  hideRegionsChildren() {
    this.childrenRegions.length = 0;
    this.selectedRegionIdLevel1 = null;
    this.renderer.removeClass(document.body, 'fixed-countries');
  }

  showChildrenRegions(id) {
    //level1 = Europe, level2 = United Kingdom, level3 = London
    this.selectedRegionIdLevel2 = id;
  }

  hideCountriesChildren() {
    this.selectedRegionIdLevel2 = null;
  }

  showChildrenRegionsChildren(id) {
    //level1 = Europe, level2 = Belgium, level3 = Brussels/Antwerp, level4 = Rest of Belgium
    this.selectedRegionIdLevel3 = id;
  }

  hideCountriesChildrenChildren() {
    this.selectedRegionIdLevel3 = null;
  }
}


